module.exports = __webpack_public_path__ + "img/Dean.db02207b.jpg";